// Loop Subscription Disclaimer Callout
// This script adds a subscription disclaimer to Loop checkout pages

(function() {
  'use strict';

  // Check if we're on a Loop subscription page
  function isLoopSubscriptionPage() {
    return window.location.pathname.includes('/a/loop_subscriptions/bundle/') || 
           window.location.pathname.includes('shop-by-goal');
  }

  // Create the subscription disclaimer callout
  function createSubscriptionDisclaimer() {
    const disclaimer = document.createElement('div');
    disclaimer.className = 'loop-subscription-disclaimer';
    disclaimer.innerHTML = `
      <p style="text-align: center; margin: 16px 0; padding: 8px 12px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 4px; color: #64748b; font-size: 13px; line-height: 1.4;">
        🚚 Fresh meals delivered weekly • Pause or cancel anytime • No commitment required
      </p>
    `;
    return disclaimer;
  }

  // Insert the disclaimer into the page
  function insertDisclaimer() {
    if (!isLoopSubscriptionPage()) {
      return;
    }

    // Check if disclaimer already exists
    if (document.querySelector('.loop-subscription-disclaimer')) {
      return;
    }

    // Wait a moment for the page to load, then add the disclaimer
    setTimeout(() => {
      // Check again in case it was added during the delay
      if (document.querySelector('.loop-subscription-disclaimer')) {
        return;
      }

      const disclaimer = createSubscriptionDisclaimer();
      
      // Try to insert near the top of the page
      const mainContent = document.querySelector('main') || document.body;
      if (mainContent.firstChild) {
        mainContent.insertBefore(disclaimer, mainContent.firstChild);
      } else {
        mainContent.appendChild(disclaimer);
      }
      
      console.log('Simple disclaimer added to Loop page');
    }, 1000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertDisclaimer);
  } else {
    insertDisclaimer();
  }

  // Also try on window load as backup
  window.addEventListener('load', insertDisclaimer);

})(); 